import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from '../../service/user.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-case-detail',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './case-detail.component.html',
  styleUrl: './case-detail.component.less',
})
export class CaseDetailComponent {
  user: any = {};
  role: any = {};
  studyUID: string = '';
  caseId: string = '';
  // viewerUIL: any = environment.host + '/vision-viewer/?mode=vr-only&studyInstanceUID=';
  viewerUIL: any = environment.host + '/vision-viewer/?studyInstanceUID=';
  // viewerUIL: any = '';
  safeUrl: any = '';
  caseDetail: any = {};
  rejectReason: string = '';
  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private router: Router, private userService: UserService, private message: NzMessageService, private modal: NzModalService) {
    this.user = JSON.parse(sessionStorage.getItem('user') || '{}');
    this.role = JSON.parse(sessionStorage.getItem('role') || '{}');
    this.route.params.subscribe((params) => {
      this.caseId = params['id']; // 获取路由参数中的 id
    });
  }

  ngOnInit() {
    this.lockReport(this.caseId);
  }

  updateViewerURL() {
    let url = this.viewerUIL + this.studyUID;
    console.log('viewerUR=>' + url);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  closeAndUnlockModal() {
    // 弹窗提示是否要解锁病例
    this.modal.confirm({
      nzTitle: '确定要解锁当前病例吗？',
      nzContent: '解锁后病例将进入公共池，不解锁则将保留在个人工作台。',
      nzOnOk: () => {
        this.userService.unlockReport(this.caseId).subscribe((res) => {
          this.message.success('解锁成功');
          this.router.navigate(['/admin/workbench']);
        });
      },
      nzOkText: '解锁',
      nzOnCancel: () => {
        this.router.navigate(['/admin/workbench']);
      },
      nzCancelText: '不解锁',
    });
  }

  closeModal() {
    this.router.navigate(['/admin/workbench']);
  }

  //获取检查详情
  getCaseDetail() {
    this.userService.getCaseDetail({ id: this.caseId }).subscribe((res) => {
      this.caseDetail = res.data;
      this.studyUID = this.caseDetail.studyInstanceUID;
      this.updateViewerURL();
    });
  }

  genderMap(type: string) {
    switch (type) {
      case 'M':
        return '男';
      case 'F':
        return '女';
      default:
        return '未知';
    }
  }

  //校验提交的参数
  checkSubmitParams() {
    if (!this.caseDetail.reportDescribe) {
      this.message.error('请填写影像学表现');
      return false;
    }
    if (!this.caseDetail.reportDiagnose) {
      this.message.error('请填写影像学结论');
      return false;
    }
    return true;
  }

  //提交报告
  submitReport() {
    if (!this.checkSubmitParams()) {
      return;
    }
    let params = {
      id: this.caseId,
      reportDescribe: this.caseDetail.reportDescribe,
      reportDiagnosis: this.caseDetail.reportDiagnose,
    };
    this.userService.submitDiagnosis(params).subscribe((res) => {
      this.message.success('提交成功');
      this.getCaseDetail();
      this.router.navigate(['/admin/workbench']);
    });
  }

  //保存报告
  saveReport() {
    let params = {
      id: this.caseId,
      reportDescribe: this.caseDetail.reportDescribe,
      reportDiagnosis: this.caseDetail.reportDiagnose,
    };
    this.userService.saveDiagnosis(params).subscribe((res) => {
      this.message.success('保存成功');
      this.getCaseDetail();
      this.router.navigate(['/admin/workbench']);
    });
  }

  //锁定报告
  lockReport(id: string) {
    this.userService.lockReport(id).subscribe((res) => {
      if (res.code === 0) {
        this.getCaseDetail();
      } else {
        this.message.error(res.message);
      }
    });
  }

  //审核报告
  auditReport() {
    this.userService.auditReport(this.caseId).subscribe((res: any) => {
      this.message.success('审核成功');
      this.getCaseDetail();
      this.router.navigate(['/admin/workbench']);
    });
  }

  //驳回报告
  rejectReport(modal: any) {
    this.modal.create({
      nzTitle: '驳回报告',
      nzContent: modal,
      nzOnOk: () => {
        this.userService.rejectReport(this.caseId, this.rejectReason).subscribe((res: any) => {
          this.message.success('驳回成功');
          this.getCaseDetail();
          this.router.navigate(['/admin/workbench']);
        });
      },
    });
  }

  //判断显示提交按钮
  showSubmitBtn() {
    return this.role.roleCode === 'reporter';
  }

  //判断显示审核通过按钮
  showAuditBtn() {
    return this.role.roleCode === 'auditor';
  }

  //判断显示驳回按钮
  showRejectBtn() {
    return this.role.roleCode === 'auditor' && this.caseDetail.status === 'REPORTED';
  }

  //显示撤回按钮
  showRecallBtn() {
    console.log(this.caseDetail.status === 'RECALLED', this.caseDetail.reporterId, this.user.id);
    // 报告状态为已驳回，且当前用户是报告医生
    if (this.caseDetail.status === 'REJECTED' && this.caseDetail.reporterId === this.user.id) {
      return false;
    }
    // 报告状态为已召回，且当前用户是报告医生
    if (this.caseDetail.status === 'RECALLED' && this.caseDetail.reporterId === this.user.id) {
      return false;
    }
    return true;
  }
}
